import { IGetReminderCount, IGetReminder, IGetReminderDetails, IReleaseReminder, ICancelReminder } from "./types";

export const getReminderCountSlr = (state: any): IGetReminderCount => state.reminders.getReminderCount;
export const getReminderSlr = (state: any): IGetReminder => state.reminders.getReminder;
export const getReminderDetailsSlr = (state: any): IGetReminderDetails => state.reminders.getReminderDetails;
export const releaseReminderSlr = (state: any): IReleaseReminder => state.reminders.releaseReminder;
export const cancelReminderSlr = (state: any): ICancelReminder => state.reminders.cancelReminder;
